module Main exposing (main)

import Browser exposing (Document)
import Browser.Navigation
import Html
import Lib.Config exposing (Config, Flags)
import Page.Form.Privacy.Model
import Page.Form.Privacy.Subscription
import Page.Form.Privacy.Update
import Page.Form.Privacy.View
import Route exposing (Route(..), routeByLocation)
import Url exposing (Url)


type alias Model =
    { config : Config, route : Route, privacyFormModel : Page.Form.Privacy.Model.Model }


main : Program Flags Model Msg
main =
    Browser.application
        { init = init
        , update = update
        , view = view
        , subscriptions = subscriptions
        , onUrlChange = routeByLocation >> RouteUpdate
        , onUrlRequest = ClickedLink
        }


type Msg
    = RouteUpdate Route
    | ClickedLink Browser.UrlRequest
    | PrivacyFormMsg Page.Form.Privacy.Model.Msg


init : Flags -> Url -> Browser.Navigation.Key -> ( Model, Cmd msg )
init flags url key =
    let
        config =
            Lib.Config.from flags key

        route =
            routeByLocation url
    in
    ( { config = config, route = route, privacyFormModel = Page.Form.Privacy.Model.init }, routeCmd route )


update : Msg -> Model -> ( Model, Cmd Msg )
update msg model =
    case msg of
        PrivacyFormMsg privacyMsg ->
            let
                ( privacyFormModel, cmd ) =
                    Page.Form.Privacy.Update.update privacyMsg model.config model.privacyFormModel
            in
            ( { model | privacyFormModel = privacyFormModel }, Cmd.map PrivacyFormMsg cmd )

        ClickedLink (Browser.Internal url) ->
            ( model, Browser.Navigation.pushUrl model.config.key (Url.toString url) )

        ClickedLink (Browser.External url) ->
            ( model, Browser.Navigation.load url )

        RouteUpdate route ->
            ( { model | route = route }, routeCmd route )


subscriptions : Model -> Sub Msg
subscriptions model =
    case model.route of
        PrivacyFormRoute ->
            Sub.map PrivacyFormMsg (Page.Form.Privacy.Subscription.subscriptions model.privacyFormModel)

        _ ->
            Sub.none


routeCmd : Route -> Cmd msg
routeCmd route =
    case route of
        NotFound ->
            Browser.Navigation.load "https://help.prima.it/"

        _ ->
            Cmd.none


view : Model -> Document Msg
view model =
    { title = pageTitle model
    , body =
        [ case model.route of
            PrivacyFormRoute ->
                Html.map PrivacyFormMsg <| Page.Form.Privacy.View.view model.config model.privacyFormModel

            NotFound ->
                Html.text ""
        ]
    }


pageTitle : Model -> String
pageTitle { route } =
    case route of
        PrivacyFormRoute ->
            "Modulo di richiesta privacy - Moduli Prima.it"

        _ ->
            "Moduli Prima.it"
